/**
 * Resolves the single polygon collection a manager should display.
 * A local draft takes precedence, while a saved collection remains available
 * during hydration and immediately after a successful auto-save.
 */
export function getManagedPolygonSource<T>(
  draft: T | null | undefined,
  saved: T | null | undefined,
): T | null {
  return draft ?? saved ?? null;
}

type FeatureCollectionLike<TFeature = unknown> = {
  type?: string;
  features: TFeature[];
  [key: string]: unknown;
};

/**
 * Produces the next explicit manager draft after removing one polygon. An empty
 * FeatureCollection is intentional: it means “the user removed the last polygon”
 * and must not be treated as an unhydrated `null` draft that falls back to saved data.
 */
export function removeManagedPolygon<T extends FeatureCollectionLike>(
  source: T,
  index: number,
): T {
  return {
    ...source,
    type: "FeatureCollection",
    features: source.features.filter((_, featureIndex) => featureIndex !== index),
  } as T;
}
